export const changeBackgroundColorRoot = (type) => {
    const root = document.getElementById("root")

    // console.log(type);
    // if (type == "grey") {
    //     root.style.background = "#F5F5F5"
    //     return
    // }
    // root.style.background = "#fff"
}